export default "/react/logoOblakoAi-2df3bfa0.png";